var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOther(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 16,
    fill: "#00C4D6"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 17.75a1.75 1.75 0 100-3.5 1.75 1.75 0 000 3.5zM16 17.75a1.75 1.75 0 100-3.5 1.75 1.75 0 000 3.5zM22 17.75a1.75 1.75 0 100-3.5 1.75 1.75 0 000 3.5z",
    fill: "#fff"
  })));
}
export default __webpack_public_path__ + "static/other.a7cdd693.svg";
export { SvgOther as ReactComponent };